export default __webpack_public_path__ + "static/thebottomline16-4a3a56f6dd7c158444ae16c21e089e55.jpg";